import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { BillingHistoryTable, ButtonBar, CheckboxList, ControlBar, Control, ModalTopBar, PageHeader, QueueFlyoutTab, Spinner, EmptyState, DataTable } from 'components';
import { getBusinessManagerPages, assignSystemUsersToPage, connectBusinessManagerPage } from 'redux/modules/adminDashboard';
var AdminFacebookPageManager = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    businessManagerPages: state.adminDashboard.businessManagerPages,
    loadingBMPages: state.adminDashboard.loadingBMPages,
    assignSysUserError: state.adminDashboard.assignSysUserError,
    isAssigningSystemUsers: state.adminDashboard.isAssigningSystemUsers,
    isConnectingBmPage: state.adminDashboard.isConnectingBmPage
  };
}, {
  getBusinessManagerPages: getBusinessManagerPages,
  assignSystemUsersToPage: assignSystemUsersToPage,
  connectBusinessManagerPage: connectBusinessManagerPage
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdminFacebookPageManager, _Component);

  var _super = _createSuper(AdminFacebookPageManager);

  function AdminFacebookPageManager(props) {
    var _this;

    _classCallCheck(this, AdminFacebookPageManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRowSelected", function (rowData) {
      console.dir(rowData);

      _this.setState({
        pageConnectModal: true,
        pageToConnect: rowData
      });
    });

    _this.state = {
      search: '',
      sysUserConnectionModal: false,
      sysUserConnectPageId: '',
      pageConnectModal: false,
      pageToConnect: null
    };
    return _this;
  }

  _createClass(AdminFacebookPageManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getBusinessManagerPages();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var filteredPages = !this.props.loadingBMPages ? this.props.businessManagerPages.filter(function (page) {
        if (!_this2.state.search) {
          return true;
        }

        return page.name.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || "".concat(page.id).indexOf(_this2.state.search) > -1;
      }) : null;
      return /*#__PURE__*/React.createElement("div", null, this.props.loadingBMPages ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'center'
        }
      }, "This may take a moment..."), /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative',
          marginLeft: 'auto',
          marginRight: 'auto'
        }
      })) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, "Below is a list of the pages that are in Business Manager."), "Search:", ' ', /*#__PURE__*/React.createElement(TextField, {
        value: this.state.search,
        onChange: function onChange(_ref) {
          var value = _ref.target.value;

          _this2.setState({
            search: value
          });
        }
      }), filteredPages && filteredPages.length === 0 && this.state.search && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Cannot find that page in Business Manager. If we are Admins of the page, the Facebook System Users may not be connected to it."), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Connect System Users",
        onClick: function onClick() {
          _this2.setState({
            sysUserConnectionModal: true
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%',
          maxHeight: 800,
          overflowY: 'scroll',
          overflowX: 'hidden'
        }
      }, /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        data: filteredPages,
        fixedHeader: true,
        height: 500,
        headerFields: [{
          name: 'Page ID',
          key: 'id',
          disableSort: true
        }, {
          name: 'Page Name',
          key: 'name',
          disableSort: true
        }],
        onRowSelection: this.handleRowSelected
      }))), /*#__PURE__*/React.createElement(Dialog, {
        title: "Connect System Users to Page",
        autoScrollBodyContent: true,
        open: this.state.sysUserConnectionModal,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            sysUserConnectionModal: false
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, "Facebook Page ID:", ' ', /*#__PURE__*/React.createElement(TextField, {
        value: this.state.sysUserConnectPageId,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;

          _this2.setState({
            sysUserConnectPageId: value
          });
        }
      })), this.props.assignSysUserError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.props.assignSysUserError), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Submit",
        disabled: this.props.isAssigningSystemUsers,
        onClick: function onClick() {
          _this2.props.assignSystemUsersToPage(_this2.state.sysUserConnectPageId).then(function () {
            _this2.setState({
              sysUserConnectPageId: '',
              sysUserConnectionModal: false
            });

            window.location.reload();
          });
        }
      })))), /*#__PURE__*/React.createElement(Dialog, {
        title: "Connect Page to Client",
        autoScrollBodyContent: true,
        open: this.state.pageConnectModal,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            pageConnectModal: false
          });
        }
      }, !!this.state.pageToConnect && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Connect ", this.state.pageToConnect.name, " (", this.state.pageToConnect.id, ") to this Client."), !!this.props.connectedPage && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "Warning: This Client already has a Facebook page connected. This will overwrite the existing Facebook page."), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            pageConnectModal: false,
            pageToConnect: null
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        disabled: this.props.isConnectingBmPage,
        label: "Connect Page",
        onClick: function onClick() {
          _this2.props.connectBusinessManagerPage(_this2.props.orgId, _this2.state.pageToConnect).then(function () {
            window.location.reload();
          });
        }
      }))))));
    }
  }]);

  return AdminFacebookPageManager;
}(Component)) || _class);
export default AdminFacebookPageManager;